import {Col, Row, Space} from "antd";
import React from "react";
import styled from 'styled-components';
import {GREE_1} from "../utils/colors";

const Title = styled.span`
  color: black;
  font-weight: bold;
`
const Text = styled.span`
  color: ${GREE_1};
`

const IconContainer = styled.span`
  color: ${GREE_1};
    border-radius: 50%;
    padding: 10px;
 
    width: 5px;
    height: 5px;
    border: 2px solid ${GREE_1};
`

export default function ContanctIcon({title, text, icon}) {
    return (
        <Row gutter={[8,8]}>
            <Col xs={3} md={5} lg={3} style={{marginTop: 5}}><IconContainer>{icon}</IconContainer></Col>
            <Col xs={21} md={19} lg={21}>
                <Row gutter={[16,4]}>
                    <Col xs={24}><Title>{title}</Title></Col>
                    <Col xs={24}> <Text>{text}</Text></Col>
                </Row>
            </Col>


        </Row>
    )
}